module.exports = __webpack_public_path__ + "img/icon_map_4_on_101.e40de29f.png";